export const postOptions = {
  replace: element => {
    const { attribs } = element

    if (
      typeof attribs?.class === "string" &&
      attribs?.class.includes("gatsby-image-wrapper")
    ) {
      element.attribs.class = `${element.attribs.class} w-full rounded-lg`
    }
  },
}
